<template>
  <div v-title data-title="提货" class="mobile">
    <div class="weui-flex">
      <div class="weui-flex__item">
        <wv-swipe :height="200" :autoplay="3000" class="home-banner">
          <wv-swipe-item
            v-for="(advertise, $index) in Advertises"
            :key="$index"
          >
            <div class="swipe-img-div">
              <img v-lazy="advertise" class="lazy-img-fadein" />
            </div>
          </wv-swipe-item>
        </wv-swipe>
      </div>
    </div>

    <div class="weui-flex" style="text-align: center; margin: 20px 0px 0px 0px">
      <div class="weui-flex__item">
        <button class="pickup">提货</button>
      </div>
      <div class="weui-flex__item">
        <button class="logistics" @click="logistics">查物流</button>
      </div>
    </div>

    <div class="weui-cells weui-cells_form" style="margin: 20px 0px">
      <div class="weui-cell">
        <div class="weui-cell__bd">
           <wvi-input
                placeholder="请输入卡号"
                ref="1"
                v-model="model.cardNumber"
                :validate-info="{errormsg:'卡号不可为空'}"
                required
            ></wvi-input>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
           <wvi-input
                placeholder="请输入提货码"
                ref="1"
                v-model="model.cardPassword"
                :validate-info="{errormsg:'提货码不可为空'}"
                required
            ></wvi-input>
        </div>
      </div>
      <div class="weui-cell weui-cell_vcode" >
        <div class="weui-cell__hd">
           <wvi-input
                placeholder="请输入验证码"
                ref="1"
                v-model="model.code"
                :validate-info="{errormsg:'验证码不可为空'}"
                required
            ></wvi-input>
        </div>
        <div class="weui-cell__bt">
          <img class="weui-vcode-img" :src="queryBindData.verificationCodeImg"  @click="getVerCode()"/>
         
        </div>
        <!-- <div class="weui-cell__ft" @click="getVerCode()">
             <p>换一张</p>
        </div> -->
      </div>
      <div class="weui-cell">
        <a href="javascript:;" class="btn-pickup" @click="deliveryGoods">提货</a>
      </div>
    </div>

    <div class="weui-panel weui-panel_access">
      <div class="weui-panel__hd">注意事项</div>
      <div class="weui-panel__bd" style="padding:10px 10px;">
            <p class="weui-media-box__desc">
              1.江浙沪建议提前两天预约发货，江浙沪以外建议提前三天预约发货。       
            </p>
             <p class="weui-media-box__desc">
              2.请保证您的提货卡在有效期内使用，过期即作废。
            </p>
             <p class="weui-media-box__desc">
              3.提货卡不设找零，不可兑换现金。
            </p>
             <p class="weui-media-box__desc">
              4.为保证准确及时送达，请准确填写收件人相关信息。
            </p>
             <p class="weui-media-box__desc">
              5.一张卡只能使用1次。
            </p>
            <p class="weui-media-box__desc">
              6.由于今夏高温天气持续，大闸蟹上市时期整体较晚，为保证品质，较大规格的大闸蟹（尤其是公蟹）套餐建议10月中旬以后进行提货。
            </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue  from 'vue'
import { Toast } from "we-vue";
import {Dialog} from 'we-vue';
import banner1 from "@/assets/img/banner1.png";
import banner2 from "@/assets/img/banner2.png";
import banner3 from "@/assets/img/banner3.png";
const imagesList = [banner1, banner2, banner3];
export default {
  name: "deliverygoods",
  data() {
    return {
      Advertises: imagesList,
      queryBindData:{
          verificationCodeImg:""
      },
      model:{
        cardNumber:"",
        cardPassword:"",    
        code: "",
        timestamp:""
      },
    };
  },
  created() {
  
  this.getVerCode();

     let currentDate=Vue.prototype.dateFormat(new Date(),"yyyy-MM-dd");
     let endDate="2026-10-31 23:59:59";
      if(Vue.prototype.dateDiff(currentDate,endDate)){
          Dialog.alert({
            title: "温馨提示",
            //message: "由于今夏高温天气持续，大闸蟹上市时期整体较晚，为保证品质，较大规格的大闸蟹（尤其是公蟹）套餐建议10月中旬以后进行提货。"
            message: "大规格的大闸蟹（尤其是公蟹）套餐建议10月底以后进行提货。"
            }).then(() => {
          });
      }
  
  },
  methods: {
    //获取图形验证码
    getVerCode() {
      this.model.timestamp=new Date().getTime();
      this.$http
        .get(this.GLOBAL.BASE_URL + `api/yearcard/getverificationcode?timestamp=${this.model.timestamp }`)
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.queryBindData.verificationCodeImg = `data:image/png;base64,${rep.Data}`;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
     validatesave: function() {
      var com = this.$refs;
      var flag = true;
      for (var c in com) {
        this.$refs[c].validate();
        flag = this.$refs[c].valid;

        if (!flag) return flag;
      }
      return flag;
    },
    //提货
    deliveryGoods(){
      if (!this.validatesave()) {
            return;
        }
        let promise= this.$http.post(this.GLOBAL.BASE_URL + "api/yearcard/checkcrab", this.model,{emulateJSON:true})
        .then(function(d) {
                var rep = JSON.parse(d.bodyText);
                if (rep.Success) {
                    let data=rep.Data;
                    if(data.state){
                        this.$router.push({
                            path: "/page/yearpurchases/editdeliveryInfo",
                            query: { YearCardType: JSON.stringify(data.YearCardType),YearCardGuid:data.YearCardGuid}
                        });
                    }else{
                        Toast.fail(data.message);
                    }
                } else {
                    Toast.fail(rep.Message);
                }
        });
    },
    logistics(){
        this.$router.push({path:"/page/yearpurchases/logistics"});
    }

  },
};
</script>

<style scoped>
.mobile{
  overflow: hidden;
}
.home-banner{
}
.swipe-img-div{
    line-height: 200px;
    height: 200px;
}
.pickup {
  width: 80px;
  height: 80px;
  border-radius: 50px;
  border: none;
  background: #d28a21;
  color: #fff;
  font-size: 14px;
}
.logistics {
  width: 80px;
  height: 80px;
  border-radius: 50px;
  border: none;
  background: #d5d5d6;
  font-size: 14px;
}
.btn-pickup {
  width: 100%;
  background: #d28a21;
  position: relative;
  display: block;
  box-sizing: border-box;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  line-height: 2.55555556;
  border-radius: 25px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}
.btn-pickup :active{
    
  color: #fff;
}
.weui-media-box__desc{
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/yearcard/deliverygoods.vue